import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { getCurrentUser, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { ActivatedRoute } from '@angular/router';
import { SimuladorService } from '../services/simulador.service';
import { HelpersService } from 'src/app/core/services/helpers.service';

@Component({
  selector: 'app-estado-tasas',
  templateUrl: './estadoTasas.component.html',
  styleUrls: ['./estadoTasas.component.scss'],
  styles: [
    `
      @media only screen and (max-width: 500px) {
        .card-body {
            flex-wrap: wrap
          }
        }
        `
  ]
})
export class EstadoTasasComponent implements OnInit {

  plazos: number[] = [];
  plazosDisponibles: number[] = [];
  tnm: number[] = [];
  seg: number[] = [];
  comision: number[] = [];
  cobranza: number[] = [];

  nuevoRegistro = {
    plazo: '' as any,
    tasa: '',
    seguro: '',
    comision: '',
    cobranza: '',
    estado: 'A'
  }

  constructor(
    private notificationService: NotificationHelper,
    private helpers: HelpersService,
    private simuladorService: SimuladorService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
  ) {
    const data = this.activatedRoute.snapshot.data;
    if (data.title) {
      this.helpers.setTitle(data.title);
    }
  }

  async traerTasas() {
    try {
      const usuario = getCurrentUser();
      const empresa = usuario ? usuario.c_emp : 'JA';
      const resp: any = await this.simuladorService.tasas(empresa || 'JA');
      if (Array.isArray(resp)) {
        this.plazos = resp;
      } else {
        console.error("La respuesta no contiene un array de plazos válido.");
        this.plazos = [];
      }
    } catch (error) {
      console.error("Error al traer tasas:", error);
    }
  }

  async traerPlazosDisponibles() {
    try {
      const usuario = getCurrentUser();
      const empresa = usuario ? usuario.c_emp : 'JA';
      const resp: any = await this.simuladorService.plazosDisponibles(empresa || 'JA');
      if (Array.isArray(resp)) {
        this.plazosDisponibles = resp;
      }
    } catch (error) {
      console.error("Error al traer plazos disponibles:", error);
    }
  }

  async traerTnm() {
    try {
      const usuario = getCurrentUser();
      const empresa = usuario ? usuario.c_emp : 'JA';
      const resp: any = await this.simuladorService.tnm(empresa || 'JA');
      if (Array.isArray(resp)) {
        this.tnm = resp;
      }
    } catch (error) {
      this.notificationService.errorMessage("Ocurrió un error desconocido.");
      hideSpinner();
    }
  }

  async traerSeg() {
    try {
      const usuario = getCurrentUser();
      const empresa = usuario ? usuario.c_emp : 'JA';
      const resp: any = await this.simuladorService.seg(empresa || 'JA');
      if (Array.isArray(resp)) {
        this.seg = resp;
      }
    } catch (error) {
      this.notificationService.errorMessage("Ocurrió un error desconocido.");
      hideSpinner();
    }
  }

  async traerComision() {
    try {
      const usuario = getCurrentUser();
      const empresa = usuario ? usuario.c_emp : 'JA';
      const resp: any = await this.simuladorService.comision(empresa || 'JA');
      if (Array.isArray(resp)) {
        this.comision = resp;
      }
    } catch (error) {
      this.notificationService.errorMessage("Ocurrió un error desconocido.");
      hideSpinner();
    }
  }

  async traerCobranza() {
    try {
      const usuario = getCurrentUser();
      const empresa = usuario ? usuario.c_emp : 'JA';
      const resp: any = await this.simuladorService.cobranza(empresa || 'JA');
      this.cobranza = [resp];
    } catch (error) {
      this.notificationService.errorMessage("Ocurrió un error desconocido.");
      hideSpinner();
    }
  }

  capturarTasa(event: Event): void {
    this.nuevoRegistro.tasa = (event.target as HTMLElement).textContent?.trim() || '';
  }

  capturarSeguro(event: Event): void {
    this.nuevoRegistro.seguro = (event.target as HTMLElement).textContent?.trim() || '';
  }

  capturarComision(event: Event): void {
    this.nuevoRegistro.comision = (event.target as HTMLElement).textContent?.trim() || '';
  }

  capturarCobranza(event: Event): void {
    this.nuevoRegistro.cobranza = (event.target as HTMLElement).textContent?.trim() || '';
  }

  async guardarNuevoRegistro(): Promise<void> {

    // Leer plazo del ngModel y los demás del DOM
    const plazoStr    = this.nuevoRegistro.plazo ? String(this.nuevoRegistro.plazo) : '';
    const tasaStr     = document.getElementById('cell-tasa')?.textContent?.trim() || '';
    const seguroStr   = document.getElementById('cell-seguro')?.textContent?.trim() || '';
    const comisionStr = document.getElementById('cell-comision')?.textContent?.trim() || '';
    const cobranzaStr = document.getElementById('cell-cobranza')?.textContent?.trim() || '';

    // Validar campos vacíos, números válidos y valores negativos
    const campos = [
      { valor: plazoStr,    nombre: 'Plazos' },
      { valor: tasaStr,     nombre: 'Tasa Efectiva Anual' },
      { valor: seguroStr,   nombre: 'Seguro' },
      { valor: comisionStr, nombre: 'Comisión' },
      { valor: cobranzaStr, nombre: 'Tasa Gasto de Cobranza' }
    ];

    for (const campo of campos) {
      if (!campo.valor) {
        this.notificationService.errorMessage(`El campo ${campo.nombre} es requerido.`);
        return;
      }
      if (campo.valor.includes(',')) {
        this.notificationService.errorMessage(`El campo ${campo.nombre} no debe contener comas. Use punto como separador decimal.`);
        return;
      }
      const num = parseFloat(campo.valor);
      if (isNaN(num)) {
        this.notificationService.errorMessage(`El campo ${campo.nombre} debe ser un número válido.`);
        return;
      }
      if (num <= 0) {
        this.notificationService.errorMessage(`El campo ${campo.nombre} debe ser mayor a cero.`);
        return;
      }
    }

    const plazoNumerico = parseFloat(plazoStr);

    // Validar plazo duplicado
    const plazoExiste = this.plazos.includes(plazoNumerico);
    if (plazoExiste) {
      this.notificationService.errorMessage(`El plazo ${plazoNumerico} ya existe.`);
      return;
    }

    try {
      showSpinner("Guardando registro...");
      const usuario = getCurrentUser();
      const usuarioId = usuario ? usuario.usuario_aplicativo : 'SADMIN';
      const empresa = usuario ? usuario.c_emp : 'JA';

      const payload = {
        plazo:    plazoNumerico,
        tasa:     parseFloat(tasaStr),
        seguro:   parseFloat(seguroStr),
        comision: parseFloat(comisionStr),
        cobranza: parseFloat(cobranzaStr),
        estado:   'A',
        usuario:  usuarioId
      };

      const res = await this.simuladorService.CrearTasa(empresa || 'JA', payload, usuarioId);

      if (!res.success) {
        this.notificationService.errorMessage(res.message || "Error al crear la tasa.");
        hideSpinner();
        return;
      }

      hideSpinner();
      this.notificationService.successMessage("Registro guardado correctamente.");
      this.limpiarFormulario();
      this.traerTasas();
      this.traerPlazosDisponibles();

    } catch (error) {
      console.error(error);
      this.notificationService.errorMessage("Ocurrió un error desconocido.");
      hideSpinner();
    }
  }

  limpiarFormulario(): void {
    this.nuevoRegistro = {
      plazo: '',
      tasa: '',
      seguro: '',
      comision: '',
      cobranza: '',
      estado: 'A'
    };

    const celdas = ['cell-tasa', 'cell-seguro', 'cell-comision', 'cell-cobranza'];
    celdas.forEach(id => {
      const el = document.getElementById(id);
      if (el) el.textContent = '';
    });
  }

  ngOnInit(): void {
    this.traerTasas();
    this.traerPlazosDisponibles(); 
    this.traerTnm();
    this.traerSeg();
    this.traerComision();
    this.traerCobranza();
  }
}